import { IncentiveService } from "../../services/incentives/incentives";

export const getEarnedIncentives = async (date,userId) => {
    try {
        const response = await IncentiveService.callIncentives(date,userId);
        return response;
    } catch (error) {
        return error.message
    }
}

export const getGemBonus = async (date,userId) => {
    try {
        const response = await IncentiveService.callGemBonus(date,userId);
        return response;
    } catch (error) {
        return error.message
    }
}



    export const getEagleManager = async (date,userId) => {
    try {
        const response = await IncentiveService.callEagleManager(date,userId);
        return response;
    } catch (error) {
        return error.message
    }
}

export const getChairmanBonus = async (date,userId) => {
    try {
        const response = await IncentiveService.callChairmanBonus(date,userId);
        return response;
    } catch (error) {
        return error.message
    }
}

export const getGlobalRally = async (date,userId) => {
    try {
        const response = await IncentiveService.callGlobalRally(date,userId);
        return response;
    } catch (error) {
        return error.message
    }
}